import { ReactNode, FC } from 'react';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { ConfigHelper } from '@devxdiscover/devhub-common';

type FusionProviderProps = {
  children: ReactNode;
};

/**
 * FusionProvider sets up the connection to Fusion.
 * @param props - The props of the FusionProvider.
 * @param props.children - The child components.
 */
export const FusionProvider: FC<FusionProviderProps> = (
  props: FusionProviderProps,
) => {
  const httpLink = createHttpLink({
    uri: ConfigHelper.instance.apiUrl('fusion/query').href,
  });

  const client = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
  });

  return <ApolloProvider client={client}>{props.children}</ApolloProvider>;
};
